// extracted by mini-css-extract-plugin
module.exports = {"header":"SuccessHeader_header__2liN9","icon":"SuccessHeader_icon__puR6V"};